<ng-template #modal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h2 class="modal-title">{{title}}</h2>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>
        {{message}}
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-danger" (click)="d();">Nein</button>
      <button class="btn btn-success" (click)="c();">Ja</button>
    </div>
  </ng-template>